import React from "react";

export default function NothingHere () {
    return (
        <div className="notfoundvid">
            <div className="nothingherep">
                Nothing Here
            </div>
            <div>
                <img src="../notfound.gif"></img>
            </div>
        </div>
    )
}